(function () {
    'use strict';

    if (typeof window === 'undefined') {
        module.exports = exports();

    } else {
        RivalIQ.models.metrics.DataSource = exports();
    }

    function exports() {

        /*
         * Implementation of an abstract DataSource interface for use with data
         * rollups
         */
        function MetricDataSource(metric, company, options) {
            return {
                getProperty: function () {
                    return metric.get('property');
                },
                getMetricValueType: function () {
                    return metric.getMetricValueType();
                },
                getMetricType: function () {
                    return metric.getMetricType();
                },
                getValues: function (property, mappings) {
                    return metric.getPropertyValues(company, property, mappings, options);
                }
            };
        }

        return MetricDataSource;
    }
})();
